import DatePicker from "react-date-picker";

import { CATEGORY, STATUS } from "../../utils/complaintsConstants";
import Input from "../Input/Input";
import Select from "../Select/Select";
import { LittleBox, SearchParams } from "./ComplaintsStatusSearchStyles";

const populateSelect = (toSelect) => {
  return toSelect.map((e, index) => {
    return (
      <option key={index} value={e.value}>
        {e.label}
      </option>
    );
  });
};

function ComplaintsStatusSearch(props) {
  const { searchHandler, searchParams, updateSearchParams } = props;

  const onCategoryChange = (ev) => {
    updateSearchParams({ ...searchParams, category: ev.target.value });
  };
  const onStatusChange = (ev) => {
    updateSearchParams({ ...searchParams, status: ev.target.value });
  };
  const onDateChange = (newDate) => {
    updateSearchParams({ ...searchParams, date: newDate });
  };
  const onCaseNumberChange = (ev) => {
    updateSearchParams({ ...searchParams, caseNumber: ev.target.value });
  };

  const searchOnClick = () => {
    searchHandler(searchParams);
  };

  return (
    <SearchParams>
      <div className="box">
        <h3>Categoria</h3>

        <Select
          className="clickable-element"
          width="16.4rem"
          height="5rem"
          value={searchParams.category}
          onChange={onCategoryChange}
        >
          {populateSelect(CATEGORY)}
        </Select>
      </div>
      <div className="box">
        <h3>Estado</h3>

        <Select
          className="clickable-element"
          width="25.6rem"
          height="5rem"
          value={searchParams.status}
          onChange={onStatusChange}
        >
          {populateSelect(STATUS)}
        </Select>
      </div>
      <div className="box">
        <h3>Desde:</h3>
        <DatePicker
          className="clickable-element"
          value={searchParams.date}
          onChange={onDateChange}
          clearIcon={null}
          dayPlaceholder={"dd"}
          locale={"es-PE"}
          monthPlaceholder={"mm"}
          showLeadingZeros={true}
          yearPlaceholder={"yy"}
          maxDate={new Date()}
        />
      </div>
      <div className="box">
        <h3>Número de caso: </h3>
        <Input
          width="25.6rem"
          height="5rem"
          value={searchParams.caseNumber}
          onChange={onCaseNumberChange}
          placeholder="Nro del caso"
        />
      </div>
      {/* on click is needed */}
      <LittleBox onClick={searchOnClick}>
        <h1>{">"}</h1>
      </LittleBox>
    </SearchParams>
  );
}

export default ComplaintsStatusSearch;
